var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesign1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 91,
    viewBox: "0 0 79 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3401_4493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.51514 19.9234C1.51514 12.7785 7.30728 6.98633 14.4522 6.98633H52.578C59.723 6.98633 65.5151 12.7785 65.5151 19.9234V58.0492C65.5151 65.1942 59.723 70.9863 52.578 70.9863H14.4522C7.30728 70.9863 1.51514 65.1942 1.51514 58.0492V19.9234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4522 7.39061H52.578C59.4997 7.39061 65.1109 13.0018 65.1109 19.9234V58.0492C65.1109 64.9709 59.4997 70.582 52.578 70.582H14.4522C7.53056 70.582 1.91942 64.9709 1.91942 58.0492V19.9234C1.91942 13.0018 7.53056 7.39061 14.4522 7.39061Z",
    stroke: "#B1C1CF",
    strokeWidth: 0.808569
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0144 36.4863C35.0144 35.934 34.5667 35.4863 34.0144 35.4863C33.4621 35.4863 33.0144 35.934 33.0144 36.4863H35.0144ZM35.0144 48.9863V36.4863H33.0144V48.9863H35.0144Z",
    fill: "#243251"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5144 47.9863V48.9863H42.5144V47.9863H40.5144ZM42.5144 29.9863C42.5144 29.434 42.0667 28.9863 41.5144 28.9863C40.9621 28.9863 40.5144 29.434 40.5144 29.9863H42.5144ZM42.5144 47.9863V29.9863H40.5144V47.9863H42.5144Z",
    fill: "#243251"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5144 47.9863V48.9863H27.5144V47.9863H25.5144ZM27.5144 43.9863C27.5144 43.434 27.0667 42.9863 26.5144 42.9863C25.9621 42.9863 25.5144 43.434 25.5144 43.9863H27.5144ZM27.5144 47.9863V43.9863H25.5144V47.9863H27.5144Z",
    fill: "#243251"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3401_4493",
    x: -11.422,
    y: 0.517773,
    width: 89.8742,
    height: 89.8742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.46856
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.46856
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.686275 0 0 0 0 0.776471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3401_4493"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3401_4493",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign1);
export default __webpack_public_path__ + "static/media/Design1.1afd1a3dd9ed06969a91d2057511c643.svg";
export { ForwardRef as ReactComponent };